<div *ngIf="ReportData != undefined">
  
  <ng-container *ngIf="tipoDocumento == 'data:application/pdf';else imagen" >
    <iframe [src]="this.safeURL" width="100%" height="600px" style="margin-top: 4em">
    </iframe>
  </ng-container>
  
  <ng-template #imagen>
    <div class="row">
      <div class="col-12" style="text-align: center;">
          <img src="{{this.tipoDocumento}};base64,{{this.ReportData}}" alt="Imagen" style="max-width: 100%;">
      </div>
    </div>
  </ng-template>

  <div class="row" style="display: none;">
    <div class="col-12">
      <div class="navbar-header toolbar">
        <div class="d-flex"></div>
        <div class="d-flex">
          <div class="d-inline-block bloque" *ngIf="firmar">
            <button type="button" title="Firmar" Style="margin-left: 10px" id="FIRMAR" name="FIRMAR"
              (click)="abrirModal(contenido)" class="btn btn-label btn-primary waves-light">
              <i class="fas label-icon"></i>
              Firmar Documento
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #contenido let-modal>
  <form (ngSubmit)="onSubmit()" [formGroup]="formFirma">
    <div class="modal-header">
      <h3 class="modal-title">Firmar Documento</h3>
      <button type="button" class="btn-close btn-rounded" data-bs-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">

      <div class="row mt-2">
        <label for="" class="col-4">Identificación del Suscriptor</label>
        <div class="col-8">
          <input type="text" class="form-control" formControlName="suscriptor" mask="00-0000-0000" [dropSpecialCharacters]="false">
        </div>
      </div>

      <div class="row mt-2">
        <label for="" class="col-4">Razón</label>
        <div class="col-8">
          <ng-select [items]="razones" bindValue="PAD36DES" bindLabel="PAD36DES" formControlName="razon"></ng-select>
        </div>
      </div>

      <div class="row mt-2">
        <label for="" class="col-4">Lugar</label>
        <div class="col-8">
          <input type="text" class="form-control" formControlName="lugar">
        </div>
      </div>

      <div class="row mt-2">
        <label for="" class="col-4">Resumen Documento</label>
        <div class="col-8">
          <input type="text" class="form-control" formControlName="resumen">
        </div>
      </div>


    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-success btn-rounded">Continuar</button>
    </div>
  </form>
</ng-template>